export default "__VITE_ASSET__a1ba5d69__"